module.exports = __webpack_public_path__ + "static/img/19.4c2bc34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/19.jpg
// module id = 91fm
// module chunks = 1